/**
 * Kennung eines Teils einer aufgeteilten Zahlung.
 *
 * bank_tx_id ist in der Datenbank eindeutig — ein Umsatz, der auf drei
 * Rechnungen verteilt wird, braucht drei Schluessel. Sie sind aus dem
 * Umsatzschluessel abgeleitet und damit bei jedem erneuten Einlesen gleich:
 * wer denselben Umsatz ein zweites Mal verteilt, trifft auf dieselben
 * Schluessel und die Datenbank weist das Ganze ab.
 */
const SPLIT_SUFFIX = /#T\d+$/;

export const splitBankTxId = (bankTxId: string, index: number): string => `${bankTxId}#T${index + 1}`;

/** Umsatzschluessel ohne Teil-Kennung — fuer die Frage "ist dieser Umsatz schon erfasst?". */
export const baseBankTxId = (bankTxId: string): string => bankTxId.replace(SPLIT_SUFFIX, '');
